import { Outlet, Navigate } from "react-router";
import { useAuthStatus } from "../../hooks/useAuthStatus";

export default function AdminRoute() {
    const {loggedIn, checkingStatus} = useAuthStatus();
    if(checkingStatus) return <>Loading...</>
    return loggedIn ? <Outlet /> : <Navigate to="/auth/login" />;
}
